import React from "react";
import {StaticFieldDisplayProps} from "../staticFieldUtils.ts";
import {
    FormLabel,
} from "../../sharedStyles.tsx";
import {StaticFieldModalConfig} from "../../../DynamicFormTypes.ts";
import {StaticFieldModalWrapper} from "../../../modals/StaticFieldModalWrapper.tsx";



const StaticModalDisplayRenderer: React.FC<StaticFieldDisplayProps> = ({ component, value }) => {
    let modalConfig: StaticFieldModalConfig;
    try {
        modalConfig = typeof value === "string" ? JSON.parse(value): value;
    }
    catch (error) {
        console.error("Invalid modal config:", error);
        return null;
    }
    return (
        <div className={`mb-4 relative flex flex-col items-center`}>
            <FormLabel component={component}></FormLabel>
            <div className={`mt-1`}>
                <StaticFieldModalWrapper
                    modalConfig={modalConfig}
                    fieldKey={component.fieldKey}
                />
            </div>
        </div>
    );
};

export const StaticModalDisplay = React.memo(StaticModalDisplayRenderer);